import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Inventory from "./pages/Inventory";
import Accounting from "./pages/Accounting";
import CRM from "./pages/CRM";
import Auctions from "./pages/Auctions";
import Audit from "./pages/Audit";
import SalesUsers from "./pages/SalesUsers";
import Commissions from "./pages/Commissions";
import MySales from "./pages/MySales";
import UserWarehouses from "./pages/UserWarehouses";
import SuperAdmin from "./pages/SuperAdmin";
import Memos from "./pages/Memos";
import Website from "./pages/Website";
import Profile from "./pages/Profile";
import Payroll from "./pages/Payroll";
import HR from "./pages/HR";
import POS from "./pages/POS";
import PublicSign from "./pages/PublicSign";
import Borrowings from "./pages/Borrowings";
import LabelDesigner from "./pages/LabelDesigner";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/sign/:kind/:token" element={<PublicSign />} />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/inventory"
              element={
                <ProtectedRoute>
                  <Inventory />
                </ProtectedRoute>
              }
            />
            <Route
              path="/accounting"
              element={
                <ProtectedRoute roles={["admin", "accountant", "staff"]}>
                  <Accounting />
                </ProtectedRoute>
              }
            />
            <Route
              path="/crm"
              element={
                <ProtectedRoute>
                  <CRM />
                </ProtectedRoute>
              }
            />
            <Route
              path="/auctions"
              element={
                <ProtectedRoute roles={["admin", "staff"]}>
                  <Auctions />
                </ProtectedRoute>
              }
            />
            <Route
              path="/audit"
              element={
                <ProtectedRoute roles={["admin"]}>
                  <Audit />
                </ProtectedRoute>
              }
            />
            <Route
              path="/sales-users"
              element={
                <ProtectedRoute roles={["admin"]}>
                  <SalesUsers />
                </ProtectedRoute>
              }
            />
            <Route
              path="/commissions"
              element={
                <ProtectedRoute roles={["admin", "sales"]}>
                  <Commissions />
                </ProtectedRoute>
              }
            />
            <Route
              path="/my-sales"
              element={
                <ProtectedRoute roles={["sales"]}>
                  <MySales />
                </ProtectedRoute>
              }
            />
            <Route
              path="/user-warehouses"
              element={
                <ProtectedRoute roles={["admin"]}>
                  <UserWarehouses />
                </ProtectedRoute>
              }
            />
            <Route
              path="/super-admin"
              element={
                <ProtectedRoute roles={["admin"]}>
                  <SuperAdmin />
                </ProtectedRoute>
              }
            />
            <Route
              path="/memos"
              element={
                <ProtectedRoute roles={["admin", "staff"]}>
                  <Memos />
                </ProtectedRoute>
              }
            />
            <Route
              path="/website"
              element={
                <ProtectedRoute roles={["admin"]}>
                  <Website />
                </ProtectedRoute>
              }
            />
            <Route
              path="/profile"
              element={
                <ProtectedRoute>
                  <Profile />
                </ProtectedRoute>
              }
            />
            <Route
              path="/payroll"
              element={
                <ProtectedRoute roles={["admin", "accountant"]}>
                  <Payroll />
                </ProtectedRoute>
              }
            />
            <Route
              path="/hr"
              element={
                <ProtectedRoute roles={["admin"]}>
                  <HR />
                </ProtectedRoute>
              }
            />
            <Route
              path="/pos"
              element={
                <ProtectedRoute>
                  <POS />
                </ProtectedRoute>
              }
            />
            <Route
              path="/borrowings"
              element={
                <ProtectedRoute roles={["admin", "staff"]}>
                  <Borrowings />
                </ProtectedRoute>
              }
            />
            <Route
              path="/label-designer"
              element={
                <ProtectedRoute roles={["admin", "staff"]}>
                  <LabelDesigner />
                </ProtectedRoute>
              }
            />
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
